"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHandlePropertiesPushData = void 0;
// (C) 2022 GoodData Corporation
var react_1 = require("react");
var sdk_model_1 = require("@gooddata/sdk-model");
var model_1 = require("../../../../../model");
function isSupportedWidgetProperties(properties) {
    var _a;
    // currently we only support the columnWidths for pivot tables
    // this should be ideally driven by the PlugVis API, not hardcoded here
    return !!((_a = properties === null || properties === void 0 ? void 0 : properties.controls) === null || _a === void 0 ? void 0 : _a.columnWidths);
}
function useHandlePropertiesPushData(widget, insight) {
    var ref = sdk_model_1.widgetRef(widget);
    var dispatch = model_1.useDashboardDispatch();
    var isInEditMode = model_1.useDashboardSelector(model_1.selectIsInEditMode);
    var visType = sdk_model_1.insightVisualizationUrl(insight).split(":")[1];
    return react_1.useCallback(function (data) {
        // propagate properties from push data only for pivot tables (this is how gdc-dashboard does it)
        if (isInEditMode && isSupportedWidgetProperties(data.properties) && visType === "table") {
            dispatch(model_1.changeInsightWidgetVisProperties(ref, data.properties));
        }
    }, [dispatch, ref, visType, isInEditMode]);
}
exports.useHandlePropertiesPushData = useHandlePropertiesPushData;
//# sourceMappingURL=useHandlePropertiesPushData.js.map